import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper" }
const _hoisted_2 = { class: "gfu-grid gfu-grid--gutter _flex" }
const _hoisted_3 = { class: "gfu-grid__cell gfu-1of3--l gfu-4of6--m gfu-1of1 _mx-a" }
const _hoisted_4 = {
  class: "gfu-box gfu-box--thick _my-3",
  "data-qa": "email-sent-box"
}
const _hoisted_5 = {
  class: "gfu-heading gfu-heading--soft gfu-box__title gfu-box__title--success",
  "data-qa": "request-sent-confirmation"
}
const _hoisted_6 = { class: "gfu-box__section" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_footer_navigation = _resolveComponent("footer-navigation")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_footer_navigation, {
      "current-page": _ctx.Resources.Layout.ContactLink
    }, null, 8 /* PROPS */, ["current-page"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.Resources.Contact.PlatformContactRequestSentTitle), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.Resources.Contact.PlatformContactRequestSentText), 1 /* TEXT */)
          ])
        ])
      ])
    ])
  ]))
}